
// 画像のサイズ
var VISUAL_W = 1200;
var VISUAL_MIM_W = 1200 - 520;
var VISUAL_H = 1581;


var $window = $(window);

// キービジュアルと箱
var $visual = $('.js-visual');
var $box = $('.js-visual-box');
var is_2nd_check = false;	// 二度目のサイズチェック

var window_h = null; // ウィンドウサイズ
var visual_h = null; // キービジュアルの高さ
var box_h = null; // キービジュアルを格納する枠の高さ
var box_w = null;


page_home();

function page_home(){
	'use strict';
	// #page-home 以外は抜ける
	if( !$('#page-home').length ) return;

	if( !$.isMobile ){
		// ビジュアルのリサイズ
		$window.on( 'resize', $.throttle( 100, resize_visual ));
		// スクロールでビジュアルを動かす
		$window.on('scroll', scroll_visual);

		setTimeout(function () {
			// console.log("initialise");
			resize_visual();
			scroll_visual();
		}, 500);
	}

	// Twitterウィジェット幅調整
	if( $('body').hasClass('isMobile') ){
	    setTimeout( function(){
	        $('.home-widget_twitter__content iframe').width(
	            $('.home-widget_twitter__content').width()
	        );
	    }, 500)
	}

	// wordprss記事一覧
	require('../module/wordpress.js');
}

/*************************
* ビジュアルのスクロール
*/
function scroll_visual(){
	// 必要なスクロール量
	var box_scroll_max = box_h - window_h;
	var visual_scroll_max = visual_h - window_h;

	// キービジュアルとのスクロール比率
	var scroll_par = visual_scroll_max / box_scroll_max;
	// 現在のスクロール量
	var now_scroll = $window.scrollTop();

	if (visual_h > window_h) {
		$visual.css({ top: -scroll_par * now_scroll });
	}
}

/*************************
* ビジュアルのリサイズ
*/
function resize_visual(){
	// var VISUAL_H_MAX = 1287

	// 一度高さを 0 にしてから枠のサイズを計測
	// $visual.hide();
	// box_w = $box.width();
	// box_h = $box.height();

	// // 縦横どっちの比率を使うか
	// var par = Math.max( box_w / VISUAL_W, box_h / VISUAL_H );

	// $visual.css({width:VISUAL_W*par, height:VISUAL_H*par});
	// $visual.show();

	// // リサイズ後を取得
	// visual_h = $visual.height();
	// box_h = $box.height();
	// window_h = $window.height();

	// 横幅の比率
	var now_visual_w = Math.max(VISUAL_MIM_W, ($window.width() - 520));
	var par = now_visual_w / VISUAL_W;
	visual_h = VISUAL_H * par;
	// box_h = $box.height();
	box_h = 1212;
	window_h = $window.height();

	// console.log("------------------");
	// console.log("window_w", $window.width());
	// console.log("now_visual_w", now_visual_w);
	// console.log("visual_h", visual_h);
	// console.log("box_h", box_h);
	// console.log("window_h", window_h);

}






//////////////////
// WEBPACK FOOTER
// ./js/page/home.js
// module id = 12
// module chunks = 0